export const processingSteps = {
  label: 'Folgearbeitsschritte',
  processingStepsFor: 'Folgearbeitsschritte für {name}',
  noProcessingSteps: 'Keine Folgearbeiten festgelegt',
  configureProcessingSteps: 'Bauteil konfigurieren',
  quantity: 'Anzahl',
  inputLabels: {
  },
  actionLabels: {
    saveConfiguration: "Speichern",
    addStep: "Hinzufügen",
  }
}